import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.to-string-tag.js";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.set.js";
import "core-js/modules/esnext.set.difference.v2.js";
import "core-js/modules/esnext.set.intersection.v2.js";
import "core-js/modules/esnext.set.is-disjoint-from.v2.js";
import "core-js/modules/esnext.set.is-subset-of.v2.js";
import "core-js/modules/esnext.set.is-superset-of.v2.js";
import "core-js/modules/esnext.set.symmetric-difference.v2.js";
import "core-js/modules/esnext.set.union.v2.js";
// 智能用例独立子项目：极简版 index.config
// 砍掉了：
//   - ktestStoreGray.init() / storeTestMgrConfig.loadAtlasKconfConfig() —— 全局灰度/Kconf 配置（发后端接口）
//   - initTecklinkNps() / fmp.setKeys() —— NPS 调研 / FMP 性能埋点
//   - 路由迁移、URL 缓存重定向、KTestHost 跳转、跨平台跳板等业务
//   - team.setUrlGID() 在路由 listen 里的反复调用（stub 后无副作用，但没必要再挂）
// 只保留：mobx strict mode、AsyncMessage 配置、根路径兜底重定向到智能用例
import { ERouter } from 'CONFIG';
import { AsyncLoader, AsyncMessage } from '@libs/a-component';
import React from 'react';
import { configure } from 'mobx';
import { initRequest } from './index.config.request';
import { initErrorHandle } from '@/index.config/index.config.errorHandle';
initRequest();
initErrorHandle();
configure({
  enforceActions: 'observed'
});
AsyncMessage.config({
  top: 32,
  duration: 2,
  maxCount: 3
});
var prom = function prom() {
  return import(/* webpackChunkName: "A..appV2" */'@/appV2');
};
var MainNode = /*#__PURE__*/function (_React$Component) {
  function MainNode() {
    _classCallCheck(this, MainNode);
    return _callSuper(this, MainNode, arguments);
  }
  _inherits(MainNode, _React$Component);
  return _createClass(MainNode, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // 智能用例独立子项目：根/旧测试中心路径统一跳到智能用例页
      var p = location.pathname;
      var redirectPaths = new Set([ERouter.ROOT, ERouter.HOME_PAGE, ERouter.TEST_MGR_ROOT, ERouter.TEST_MGR_TEST_DESIGN, ERouter.KTEST_WORKBENCH, ERouter.PERSONAL_WORK_BENCH_PERSONAL_VIEW]);
      if (redirectPaths.has(p)) {
        location.href = ERouter.KTEST_KCASE_AI_GENERATE_CASE;
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(AsyncLoader, {
        compoLazy: prom,
        fallback: /*#__PURE__*/React.createElement("div", null)
      });
    }
  }]);
}(React.Component);
var AppConfig = {
  renderMainNode: function renderMainNode() {
    return /*#__PURE__*/React.createElement(MainNode, null);
  }
};
export default AppConfig;